
import { DynamicParameter, InsightDetails, Operator } from "@/types/insights"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"

import Guid from "@/scripts/guid"

import vSelect from "vue-select"
import ParameterValue from "../Controls/ParameterValue.vue"

import { dataTypeParameters, DataType } from "@/types/dataType"
import { cloneDeep } from "lodash"
import { DataSource } from "@/types/dataSourceItem"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"
import LimitedSelect from "../Fields/LimitedSelect.vue"

@Component({
	components: {
		"v-select": vSelect,
		"limited-select": LimitedSelect,
		"parameter-value": ParameterValue,
		"help-icon": HelpIcon
	}
})
export default class DynamicParameters extends Vue {
	@Prop({ default: null })
	value!: DynamicParameter[] | null

	@Prop({ default: null })
	insight!: InsightDetails;

	@Prop({ default: () => [] })
	dataSources!: DataSource[]

	@Prop({ default: () => [] })
	includedParameters!: DynamicParameter[]

	@Prop({ default: () => [] })
	globalInsightParameters!: DynamicParameter[]

	parameterTypes = dataTypeParameters

	dataSourceType = DataType.array

	public get allValid (): boolean {
		return this.value
			? this.value.every(p => this.parameterNameValid(p.name))
			: true
	}

	get parameters (): DynamicParameter[] {
		return this.value
			? this.value.filter(v => !!v.key)
			: []
	}

	get parameterValueOptions () {
		return this.parameters.filter(p => !!p.key).toDictionaryMapValue(p => p.key, p => {
			return {
				operator: p.dataType === DataType.userRole
					? Operator.Contains
					: p.dataType === DataType.dateRange
						? Operator.DateRange
						: Operator.Equals,
				searchClauseParameters: null,
				fieldData: {
					fieldDataType: p.dataType === DataType.dateRange ? DataType.dateTime : p.dataType,
					dataSourceId: p.dataType === this.dataSourceType ? p.dataSourceId : null,
					dataType: p.dataType === DataType.userRole ? "user-role" : null
				}
			}
		})
	}

	@Watch("allValid")
	validChanged (nowValid: boolean) {
		this.$emit("validChanged", nowValid)
	}

	addParameter () {
		const value = cloneDeep(this.value) || []
		value.push({
			key: Guid.newGuid(),
			name: "",
			dataType: DataType.string,
			dataSourceId: null
		})

		this.$emit("input", value)
	}

	removeParameter (parameter: DynamicParameter) {
		this.$emit("input", this.value!.filter(p => p.key !== parameter.key))
	}

	parameterNameValid (parameterName: string): boolean {
		return parameterName !== null && parameterName.length > 0 &&
			this.parameters.filter(p => p.name === parameterName).length < 2
	}

	clearDataSource (parameter: DynamicParameter, type: DataType) {
		if (type !== DataType.array) {
			parameter.dataSourceId = null
		}
	}

	includedParametersOfType (type: DataType): DynamicParameter[] {
		return this.includedParameters.filter(p => p.dataType === type)
	}

	private parameterDefaultValueChanged (parameter: DynamicParameter, parameterValue: any) {
		const newValue = this.value ? cloneDeep(this.value) : []

		switch (parameter.dataType) {
			case DataType.string:
				if (parameterValue === "") {
					parameterValue = null // empty string implies no default value
				}
				break
		}

		newValue.firstOrDefault(param => param.key === parameter.key).defaultValue = parameterValue

		this.$emit("input", newValue)
	}
}

